import { getApps, initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDNbCPORlXzZfcKskkfxMaTl_CmEf6ICwI",
  authDomain: "the3dcreatorapp.firebaseapp.com",
  projectId: "the3dcreatorapp",
  storageBucket: "the3dcreatorapp.firebasestorage.app",
  messagingSenderId: "195135879148",
  appId: "1:195135879148:web:44b2afe0197b1c050f32c9",
  measurementId: "G-JNXT6DCR4G",
};

const firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export default firebaseApp;
